/**
 * @override
 * 自定义积木，要采用统一样式，必须在定义积木样式，
 * 设置output:'String/Number/Boolean/...'
 *
 */
import Blockly from 'blockly'
// define a robot
Blockly.Blocks['gta_define_robot'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('请连接一个robot ID')
      .appendField(new Blockly.FieldTextInput('robot'), 'NAME')
    this.setStyle('event_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('在同个局域网内，搜寻STA模式下的机器设备，并建立连接。参数：string类型，指代机器设备的名称（ID）默认值为 "robot"。返回无。')
    this.setHelpUrl(Blockly.Msg['gta_define_robot'])
  },
}

Blockly.Python['gta_define_robot'] = function(block) {
  var name = block.getFieldValue('NAME')
  var code = `robot = Robot('${name}')\n`
  return code
}


//   设置灯光的rgb颜色
Blockly.Blocks['gta_set_light_color'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('设置rgb颜色： r')
      .appendField(new Blockly.FieldNumber(0, 0, 255, 1), 'RED')
      .appendField(' g')
      .appendField(new Blockly.FieldNumber(0, 0, 255, 1), 'GREEN')
      .appendField(' b')
      .appendField(new Blockly.FieldNumber(0, 0, 255, 1), 'BLUE')
    this.setStyle('light_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('设置灯光颜色。参数：rgb颜色数值，值范围0~255。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_set_light_color'])
  },
}

Blockly.Python['gta_set_light_color'] = function(block) {
  var number_red = block.getFieldValue('RED')
  var number_green = block.getFieldValue('GREEN')
  var number_blue = block.getFieldValue('BLUE')
  var code = `robot.set_light_color(r=${number_red},g=${number_green},b=${number_blue})\n`
  return code
}

//   灯光配置：常亮模式
Blockly.Blocks['gta_set_light_mode_on'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('常亮模式：')
      .appendField(' 持续时间')
      .appendField(new Blockly.FieldNumber(0, 0, 30000, 1), 'duration')
      .appendField('ms')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('light_blocks')
    this.setTooltip('配置灯光的闪烁方式和持续时间。常亮状态持续指定时间。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_set_light_mode_on'])
  },
}

Blockly.Python['gta_set_light_mode_on'] = function(block) {
  // var dropdown_name = block.getFieldValue('NAME')
  var number_duration = block.getFieldValue('duration')
  var code = `robot.set_light_mode(mode='on', duration=${number_duration})\n`
  return code
}

//   灯光配置：闪烁模式
Blockly.Blocks['gta_set_light_mode_blink'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('闪烁模式：')
      .appendField(' 持续时间')
      .appendField(new Blockly.FieldNumber(0, 0, 30000, 1), 'duration')
      .appendField('ms')
      .appendField(' 亮灯间隔')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'on_time')
      .appendField('ms')
      .appendField(' 熄灭间隔')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'off_time')
      .appendField('ms')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('light_blocks')
    this.setTooltip('配置灯光的闪烁方式和持续时间。闪烁状态持续指定时间，点亮指定时间，熄灭指定时间。参数：持续时间（0）ms，0~30000; 默认值：0。亮灯间隔（0）ms,0~30000; 默认值：0。熄灭间隔（0）ms,0~30000; 默认值：0；。')
    this.setHelpUrl(Blockly.Msg['gta_set_light_mode_blink'])
  },
}

Blockly.Python['gta_set_light_mode_blink'] = function(block) {
  var number_duration = block.getFieldValue('duration')
  var number_on_time = block.getFieldValue('on_time')
  var number_off_time = block.getFieldValue('off_time')

  var code = `robot.set_light_mode(mode='blink', duration=${number_duration}, on_time=${number_on_time}, off_time=${number_off_time})\n`
  return code
}
//   灯光配置：闪烁模式
Blockly.Blocks['gta_set_light_mode_breathe'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('渐变模式：')
      .appendField(' 持续时间')
      .appendField(new Blockly.FieldNumber(0, 0, 30000, 1), 'duration')
      .appendField('ms')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('light_blocks')
    this.setTooltip('配置灯光的闪烁方式和持续时间。渐变呼吸状态持续指定时间。参数：持续时间（0）ms。;0~30000; 默认值：0。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_set_light_mode_breathe'])
  },
}

Blockly.Python['gta_set_light_mode_breathe'] = function(block) {
  var number_duration = block.getFieldValue('duration')
  var code = `robot.set_light_mode(mode='breathe', duration=${number_duration})\n`
  return code
}

// 启动灯光 或 熄灭灯光。
Blockly.Blocks['gta_light_on_of'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('灯光')
      .appendField(
        new Blockly.FieldDropdown([
          ['启动', 'on'],
          ['关闭', 'off'],
        ]),
        'ON'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('light_blocks')
    this.setTooltip('启动灯光 或 熄灭灯光。选项：灯光（启动）、灯光（关闭）。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_light_on_of'])
  },
}

Blockly.Python['gta_light_on_of'] = function(block) {
  var dropdown_on = block.getFieldValue('ON')
  var code = dropdown_on == 'on' ? `robot.light_on()\n` : `robot.light_off()\n`
  return code
}

/**
 * motions组件
 * */

// 定向运动
Blockly.Blocks['gta_move_in_open_loop'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('定向运动：')
      .appendField('速度')
      .appendField(
        new Blockly.FieldDropdown([
          ['前进2挡', '-2'],
          ['前进1挡', '-1'],
          ['后退1挡', '1'],
          ['后退2挡', '2'],
        ]),
        'SPEED'
      )
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout ')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('drive_blocks')
    this.setTooltip('控制机器车轮运行。开环方式，以规定速度运行，指定时间后停止。参数：速度前进挡、速度后退档。')
    this.setHelpUrl(Blockly.Msg['gta_move_in_open_loop'])
  },
}

Blockly.Python['gta_move_in_open_loop'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_timeout_ = block.getFieldValue('timeout ')
  var dropdown_block = block.getFieldValue('block')

  // TODO: Assemble Python into code variable.
  var code = `robot.move_in_open_loop(speed=${dropdown_speed}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

//   定距运动
Blockly.Blocks['gta_straight_move'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('定距运动：')
      .appendField(
        new Blockly.FieldDropdown([
          ['慢速', '1'],
          ['常速', '2'],
          ['快速', '3'],
        ]),
        'SPEED'
      )
      .appendField('  距离')
      .appendField(new Blockly.FieldNumber(0, -1000, 1000, 1), 'distance')
      .appendField('mm')
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('drive_blocks')
    this.setTooltip('控制机器车轮运行。开环方式，以规定速度运行指定距离，超过指定时间后停止。参数：速度（慢速、常速、快速）；距离；停止时间、是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_straight_move'])
  },
}

Blockly.Python['gta_straight_move'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_distance_ = block.getFieldValue('distance')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.straight_move(speed=${dropdown_speed},distance=${number_distance_}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

// 闭环车轮运动 -转角运动
Blockly.Blocks['gta_robot_turn'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('转角运动：')
      .appendField('速度挡')
      .appendField(
        new Blockly.FieldDropdown([
          ['1', '1'],
          ['2', '2'],
          ['3', '3'],
        ]),
        'SPEED'
      )
      .appendField('  转弯')
      .appendField(new Blockly.FieldNumber(0, -360, 360, 1), 'angle')
      .appendField('°')
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('drive_blocks')
    this.setTooltip('控制机器车轮转弯。闭环控制，以规定速度精确转动指定角度，超过指定时间后停止。参数：速度挡(1挡、2挡、3挡)；转弯， -360°~360°;停止时间ms，0~10000ms;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_turn'])
  },
}

Blockly.Python['gta_robot_turn'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_angle_ = block.getFieldValue('angle')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.turn(speed=${dropdown_speed},angle=${number_angle_}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

// 小臂运动 开环方式，以时间为停止标志。
Blockly.Blocks['gta_forearm_move_in_open_loop'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('小臂运动： ')
      .appendField('速度')
      .appendField(
        new Blockly.FieldDropdown([
          ['向外伸展2挡', '2'],
          ['向外伸展1挡', '1'],
          ['向内收缩2挡', '-2'],
          ['向内收缩1挡', '-1'],
        ]),
        'SPEED'
      )
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制小臂运行。开环方式，以规定速度运行，指定时间后停止。参数：速度（向外伸展2挡、1挡、向内收缩2挡、1挡）；停止时间（0）ms，0~10000;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_forearm_move_in_open_loop'])
  },
}

Blockly.Python['gta_forearm_move_in_open_loop'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.forearm_move_in_open_loop(speed=${dropdown_speed},timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

//小臂运行角度
Blockly.Blocks['gta_forearm_move'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('小臂运行角度：')
      .appendField(
        new Blockly.FieldDropdown([
          ['慢速', '1'],
          ['常速', '2'],
          ['快速', '3'],
        ]),
        'SPEED'
      )
      .appendField('  运行角度')
      .appendField(new Blockly.FieldNumber(0, 0, 210, 0), 'angle')
      .appendField('°')
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(5000, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制小臂运行。开环方式，以规定速度运行规定角度，指定时间后停止。参数：速度（慢速、常速、快速）；停止时间（0）ms，0~10000;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_forearm_move'])
  },
}

Blockly.Python['gta_forearm_move'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_angle_ = block.getFieldValue('angle')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.forearm_move(speed=${dropdown_speed},angle=${number_angle_}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

// 大臂运动 开环方式，以时间为停止标志。
Blockly.Blocks['gta_arm_move_in_open_loop'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('大臂运动： ')
      .appendField('速度挡')
      .appendField(
        new Blockly.FieldDropdown([
          ['向前伸展2挡', '2'],
          ['向前伸展1挡', '1'],
          ['向后伸展2挡', '-2'],
          ['向后伸展1挡', '-1'],
        ]),
        'SPEED'
      )
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制大臂运行。开环方式，以规定速度运行，指定时间后停止。参数：速度（向前伸展2挡、向前伸展1挡、向前伸展2挡、向前伸展1挡）；停止时间（0）ms，0~10000;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_arm_move_in_open_loop'])
  },
}

Blockly.Python['gta_arm_move_in_open_loop'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.arm_move_in_open_loop(speed=${dropdown_speed},timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

//大臂运行角度
Blockly.Blocks['gta_arm_move'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('大臂运行角度：')
      .appendField(
        new Blockly.FieldDropdown([
          ['慢速', '1'],
          ['常速', '2'],
          ['快速', '3'],
        ]),
        'SPEED'
      )
      .appendField('  运行角度')
      .appendField(new Blockly.FieldNumber(0, 0, 160, 1), 'angle')
      .appendField('°')
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(5000, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制大臂运行。开环方式，以规定速度运行规定角度，指定时间后停止。参数：速度（慢速、常速、快速）；运行角度（0）°， 0～160°；停止时间（0）ms，0~10000;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_arm_move'])
  },
}

Blockly.Python['gta_arm_move'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_angle_ = block.getFieldValue('angle')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.arm_move(speed=${dropdown_speed},angle=${number_angle_}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

// 头部运动 开环方式，以时间为停止标志。
Blockly.Blocks['gta_head_move_in_open_loop'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('头部运动： ')
      .appendField('速度挡')
      .appendField(
        new Blockly.FieldDropdown([
          ['向下伸展2挡', '-2'],
          ['向下伸展1挡', '-1'],
          ['向上伸展2挡', '2'],
          ['向上伸展1挡', '1'],
        ]),
        'SPEED'
      )
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制头部运行。开环方式，以规定速度运行，指定时间后停止。参数：速度（向下伸展2挡、向下伸展1挡、向上伸展2挡、向上伸展1挡）；停止时间（0）ms，0~10000;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_head_move_in_open_loop'])
  },
}

Blockly.Python['gta_head_move_in_open_loop'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.head_move_in_open_loop(speed=${dropdown_speed},timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

//头部运行角度
Blockly.Blocks['gta_head_move'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('头部运行角度：')
      .appendField(
        new Blockly.FieldDropdown([
          ['慢速', '1'],
          ['常速', '2'],
          ['快速', '3'],
        ]),
        'SPEED'
      )
      .appendField('  运行角度')
      .appendField(new Blockly.FieldNumber(0, -15, 65, 1), 'angle')
      .appendField('°')
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(2000, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制头部运行。开环方式，以规定速度运行规定角度，指定时间后停止。参数：速度（慢速、常速、快速）；运行角度（0）°， 0～160°；停止时间（0）ms，0~10000;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_head_move'])
  },
}

Blockly.Python['gta_head_move'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_angle_ = block.getFieldValue('angle')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.head_move(speed=${dropdown_speed},angle=${number_angle_}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

// 手抓运动 开环方式，以时间为停止标志。
Blockly.Blocks['gta_paw_move_in_open_loop'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('手抓运动： ')
      .appendField('速度挡')
      .appendField(
        new Blockly.FieldDropdown([
          ['向外张开2挡', '-2'],
          ['向外张开1挡', '-1'],
          ['向内收缩2挡', '2'],
          ['向内收缩1挡', '1'],
        ]),
        'SPEED'
      )
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(0, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制手抓运行。开环方式，以规定速度运行，指定时间后停止。参数：速度（向外张开2挡、向外张开1挡、向内收缩2挡、向内收缩1挡）；停止时间（0）ms，0~10000ms;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_paw_move_in_open_loop'])
  },
}

Blockly.Python['gta_paw_move_in_open_loop'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.paw_move_in_open_loop(speed=${dropdown_speed},timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

//手抓运行角度：
Blockly.Blocks['gta_paw_move'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('手抓运行角度：')
      .appendField(
        new Blockly.FieldDropdown([
          ['慢速', '1'],
          ['常速', '2'],
          ['快速', '3'],
        ]),
        'SPEED'
      )
      .appendField('  运行角度')
      .appendField(new Blockly.FieldNumber(0, 0, 100, 1), 'angle')
      .appendField('°')
      .appendField('  停止时间')
      .appendField(new Blockly.FieldNumber(2000, 0, 10000, 1), 'timeout')
      .appendField('ms')
      .appendField('是否阻塞')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['never', 'never'],
          ['all', 'all'],
        ]),
        'block'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('posture_blocks')
    this.setTooltip('控制手抓运行。开环方式，以规定速度运行规定角度，指定时间后停止。参数：速度（慢速、常速、快速）；运行角度（0）°， 0～160°；停止时间（0）ms，0~10000 ms;是否阻塞(auto/never/all)。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_paw_move'])
  },
}

Blockly.Python['gta_paw_move'] = function(block) {
  var dropdown_speed = block.getFieldValue('SPEED')
  var number_angle_ = block.getFieldValue('angle')
  var number_timeout_ = block.getFieldValue('timeout')
  var dropdown_block = block.getFieldValue('block')
  // TODO: Assemble Python into code variable.
  var code = `robot.paw_move(speed=${dropdown_speed},angle=${number_angle_}, timeout=${number_timeout_}, block='${dropdown_block}')\n`
  return code
}

/**
 * player 组件
 * */
 Blockly.Blocks['gta_robot_display_audio'] = {
  init: function() {
    this.appendDummyInput().appendField('设备播放音频：')
    this.appendValueInput('NAME').setCheck(null)
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('robot_print')
    this.setTooltip('上传一个音频文件至服务器，使用积木调用接口，最终在果小聪播放音频。参数：音频url。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_display_audio'])
  },
}


Blockly.Python['gta_robot_display_audio'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_NONE
  )
  console.log('value_name',value_name)
  // TODO: Assemble Python into code variable.
  var code = `robot.display_audio(${value_name})\n`
  return code
}



Blockly.Blocks['gta_robot_tts'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('转语音：')
      .appendField(' 文本')
      .appendField(new Blockly.FieldTextInput('default'), 'TEXT')
      .appendField('  文本名：')
      .appendField(new Blockly.FieldTextInput('default'), 'fileName')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('voice_blocks')
    this.setTooltip('实现文字转语音功能，存储再指定文本名的文件内，最终可通过机器人播放。参数：文本（default），内容长度不大于100个；文本名（default），长度不能大于10个。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_tts'])
  },
}

Blockly.Python['gta_robot_tts'] = function(block) {
  var text_text = block.getFieldValue('TEXT')
  var text_filename = block.getFieldValue('fileName')

  if (text_text.length > 100) {
    console.error('文字/容不能大于100')
  }

  if (text_filename.length > 100) {
    console.error('文本名字符不能大于10')
  }
  var code = `robot.tts('${text_text}','${text_filename}')\n`
  return code
}

Blockly.Blocks['gta_robot_play'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('播放转语音的文本名：')
      .appendField(new Blockly.FieldTextInput('default'), 'fileName')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('voice_blocks')
    this.setTooltip('通过机器人播放指定文本名的文件。参数：文本名（default），长度不能大于10个。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play'])
  },
}

Blockly.Python['gta_robot_play'] = function(block) {
  var text_filename = block.getFieldValue('fileName')
  if (text_filename.length > 100) {
    console.error('文本名符不能大于10')
  }
  var code = `robot.play('${text_filename}')\n`
  return code
}

// 播放状态
Blockly.Blocks['gta_get_play_status'] = {
  init: function() {
    this.appendDummyInput().appendField('获取文本转语音播放状态')
    this.setInputsInline(true)
    this.setOutput(true, null);
    this.setStyle('voice_blocks')
    this.setTooltip('获取文本转语音播放状态。返回值为布尔值。')
    this.setHelpUrl(Blockly.Msg['gta_get_play_status'])
  },
}

Blockly.Python['gta_get_play_status'] = function(block) {
  var code = 'robot.get_play_status()'
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

// 播放音量
Blockly.Blocks['gta_set_volume'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('设置播放音量')
      .appendField(
        new Blockly.FieldDropdown([
          ['1', '1'],
          ['2', '2'],
          ['3', '3'],
          ['4', '4'],
          ['5', '5'],
        ]),
        'volume'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('voice_blocks')
    this.setTooltip('设置音频播放音量。参数：音量。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_set_volume'])
  },
}

Blockly.Python['gta_set_volume'] = function(block) {
  var dropdown_volume = block.getFieldValue('volume')
  var code = `robot.set_volume(${dropdown_volume})\n`
  return code
  // return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

// 播放状态
Blockly.Blocks['gta_get_volume'] = {  
  init: function() {
    this.appendDummyInput().appendField('获取播放音量')
    this.setInputsInline(true)
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setStyle('voice_blocks')
    this.setTooltip('获取播放音量。无参数。无返回')
    this.setHelpUrl(Blockly.Msg['gta_get_volume'])
  },
}

Blockly.Python['gta_get_volume'] = function(block) {
  var code = 'robot.get_volume()'
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
  // return code
}

/**
 * file 组件
 * */

// //  上传图片
// Blockly.Blocks['gta_robot_upload'] = {
//   init: function() {
//     this.appendDummyInput().appendField('上传图片到机器人')
//     this.appendValueInput('NAME').setCheck(null)
//     this.setInputsInline(true)
//     this.setPreviousStatement(true, null)
//     this.setNextStatement(true, null)
//     this.setStyle('event_blocks')
//     this.setTooltip('')
//     this.setHelpUrl('')
//   },
// }


// Blockly.Python['gta_robot_upload'] = function(block) {
//   var value_name = Blockly.Python.valueToCode(
//     block,
//     'NAME',
//     Blockly.Python.ORDER_ATOMIC
//   )
//   // TODO: Assemble Python into code variable.
//   var code = `robot.upload('${value_name}')\n`
//   return code
// }


//屏幕显示（图片）
Blockly.Blocks['gta_robot_display_image'] = {
  init: function() {
    this.appendDummyInput().appendField('设备屏幕显示图片：')
    this.appendValueInput('NAME').setCheck(null)
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('robot_print')
    this.setTooltip('上传一张本地图片至服务器，使用积木调用接口，最终在果小聪屏幕显示图片。参数：图片路径。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_display_image'])
  },
}


Blockly.Python['gta_robot_display_image'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_NONE
  )
  // TODO: Assemble Python into code variable.
  var code = `robot.display_image(${value_name})\n`
  return code
}


/**
 * screen 组件
 * */

//  显示摄像头画面
Blockly.Blocks['gta_robot_show_camera'] = {
  init: function() {
    this.appendDummyInput().appendField('设备显示摄像头画面')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('robot_print')
    this.setTooltip('打开机器的摄像头显示画面。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_show_camera'])
  },
}
Blockly.Python['gta_robot_show_camera'] = function(block) {
  var code = `robot.show_camera()\n`
  return code
}

// //  停止摄像头画面
// Blockly.Blocks['gta_stop_showing'] = {
//   init: function() {
//     this.appendDummyInput().appendField('停止robot摄像头')
//     this.setInputsInline(true)
//     this.setPreviousStatement(true, null)
//     this.setNextStatement(true, null)
//     this.setStyle('robot_print')
//     this.setTooltip('停止机器屏幕的画面显示。无参数。无返回。')
//     this.setHelpUrl('gta_stop_showing')
//   },
// }
// Blockly.Python['gta_stop_showing'] = function(block) {
//   var code = `robot.stop_showing()\n`
//   return code
// }

/**
 * emotion 表情组件
 * */


Blockly.Blocks.gta_robot_play_emotion_1 = {
  init: function() {
    this.appendDummyInput()
      .appendField('播放：')
      .appendField(
        new Blockly.FieldDropdown([
          ['apple苹果', 'a_apl'],
          ['dog狗', 'dog_a'],
          ['cat猫', 'c_cat'],
          ['block积木', 'b_blk'],
        ]),
        'emotion'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('设备播放定制情绪有：apple苹果、dog狗、cat猫、block积木。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play_emotion_1'])
  }
}
Blockly.Python.gta_robot_play_emotion_1 = function(block) {
  var dropdown_emotion = block.getFieldValue('emotion')
  var code = "robot.play_emotion('"+dropdown_emotion+"')\n"
  return code
}


Blockly.Blocks.gta_robot_play_emotion_2 = {
  init: function() {
    this.appendDummyInput()
      .appendField('表情：')
      .appendField(
        new Blockly.FieldDropdown([
          ['生气', 'agy_a'],
          ['开心a', 'hpy_a'],
          ['开心b', 'hpy_b'],
          ['带羞涩的开心', 'hpy_sl'],//happy with shy
          ['害怕a', 'scr_a'],
          ['害怕b', 'scr_b'],
          ['难过a', 'sd_a'],
          ['难过b', 'sd_e'],
          ['叹气', 'sgh_a'],
          ['害羞', 'shy_a'],
       
        ]),
        'emotion'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('设备播放定制表情有：生气、开心a、开心b、带羞涩的开心、害怕a、害怕b、难过a、难过b、叹气、害羞a。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play_emotion_2'])
  }
}
Blockly.Python.gta_robot_play_emotion_2 = function(block) {
  var dropdown_emotion = block.getFieldValue('emotion')
  var code = "robot.play_emotion('"+dropdown_emotion+"')\n"
  return code
}

Blockly.Blocks.gta_robot_play_emotion_3 = {
  init: function() {
    this.appendDummyInput()
      .appendField('表情：')
      .appendField(
        new Blockly.FieldDropdown([
          ['睡觉', 'slp_a'],
          ['打喷嚏', 'snz_a'],
          ['震惊a', 'sok_a'],
          ['震惊b', 'sok_wt'],
          ['满怀希望', 'st_a'],
          ['激动的tada', 'td_a'],//exciting tada
          ['慢慢醒来', 'wgl_a'],
          ['伸展a', 'ywn_a'],
          ['伸展b', 'ywn_b'],
        ]),
        'emotion'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('设备播放定制表情有：睡觉、打喷嚏、震惊a、震惊b、满怀希望、激动的tada、慢慢醒来、伸展a、伸展b。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play_emotion_3'])
  }
}
Blockly.Python.gta_robot_play_emotion_3 = function(block) {
  var dropdown_emotion = block.getFieldValue('emotion')
  var code = "robot.play_emotion('"+dropdown_emotion+"')\n"
  return code
}

Blockly.Blocks.gta_robot_play_emotion_4 = {
  init: function() {
    this.appendDummyInput()
      .appendField('表情：')
      .appendField(
        new Blockly.FieldDropdown([
          ['爱心', 'hrt_a'],
          ['喵喵', 'cat_a'],//see a cat
          ['喜欢炫耀', 'hpy_swl'],
          ['打盹a', 'nap_a'],
          ['打盹b', 'nap_b'],
          ['怀疑', 'dbt_a'],
          ['头晕', 'dizy'],
          ['蒙眼睛a', 'obt_a'],
          ['蒙眼睛b', 'obt_b'],
          ['蒙眼睛c', 'obt_c'],
          ['转身跳舞', 'dns_a'],
        ]),
        'emotion'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('设备播放定制表情有：爱心、喵喵、喜欢炫耀、打盹a、打盹b、怀疑、头晕、蒙眼睛a、蒙眼睛b、蒙眼睛c、转身跳舞。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play_emotion_4'])
  }
}
Blockly.Python.gta_robot_play_emotion_4 = function(block) {
  var dropdown_emotion = block.getFieldValue('emotion')
  var code = "robot.play_emotion('"+dropdown_emotion+"')\n"
  return code
}

Blockly.Blocks.gta_robot_play_emotion_5 = {
  init: function() {
    this.appendDummyInput()
      .appendField('说：')
      .appendField(
        new Blockly.FieldDropdown([
          ['你好a', 'hi_a'],
          ['你好b', 'hi_b'],
          ['你好c', 'hll_a'],
          ['你好吗', 'hry'],
          ['很高兴见到你', 'ntsy'],
        ]),
        'emotion'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('设备播放说的语言表情：你好a、你好b、你好c、你好吗、很高兴见到你。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play_emotion_5'])
  }
}
Blockly.Python.gta_robot_play_emotion_5 = function(block) {
  var dropdown_emotion = block.getFieldValue('emotion')
  var code = "robot.play_emotion('"+dropdown_emotion+"')\n"
  return code
}

Blockly.Blocks.gta_robot_play_emotion_6 = {
  init: function() {
    this.appendDummyInput()
      .appendField('唱：')
      .appendField(
        new Blockly.FieldDropdown([
          ['《little star》', 'song_a'],
          ['《jingle bell》', 'song_b'],
          ['《ten little fingers》', 'song_c'],
        ]),
        'emotion'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('设备播放唱歌曲目：《little star》、《jingle bell》、《ten little fingers》。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_play_emotion_6'])
  }
}
Blockly.Python.gta_robot_play_emotion_6 = function(block) {
  var dropdown_emotion = block.getFieldValue('emotion')
  var code = "robot.play_emotion('"+dropdown_emotion+"')\n"
  return code
}


// 打开表情
Blockly.Blocks['gta_turn_on_expression'] = {
  init: function() {
    this.appendDummyInput().appendField('打开屏幕表情')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('打开屏幕的表情（默认打开）。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_turn_on_expression'])
  },
}
Blockly.Python['gta_turn_on_expression'] = function(block) {
  var code = `robot.turn_on_expression()\n`
  return code
}

// 关闭表情
Blockly.Blocks['gta_turn_off_expression'] = {
  init: function() {
    this.appendDummyInput().appendField('关闭屏幕表情')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('emotion_blocks')
    this.setTooltip('关闭屏幕表情。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_turn_off_expression'])
  },
}
Blockly.Python['gta_turn_off_expression'] = function(block) {
  var code = `robot.turn_off_expression()\n`
  return code
}
// 开启运动-通过这个接口可打开一个运行（轮子或手臂）
Blockly.Blocks['gta_turn_on_motion'] = {
  init: function() {
    this.appendDummyInput().appendField('开启运动')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('开启一个运动（轮子或手臂）。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_turn_on_motion'])
  },
}
Blockly.Python['gta_turn_on_motion'] = function(block) {
  var code = `robot.turn_on_motion()\n`
  return code
}
// 关闭运动-通过这个接口可关闭一个运行（轮子或手臂）
Blockly.Blocks['gta_turn_off_motion'] = {
  init: function() {
    this.appendDummyInput().appendField('关闭运动')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('event_blocks')
    this.setTooltip('关闭一个运动（轮子或手臂）。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_turn_off_motion'])
  },
}
Blockly.Python['gta_turn_off_motion'] = function(block) {
  var code = `robot.turn_off_motion()\n`
  return code
}

/**
 * face-detection 组件
 * */

//   检测人脸
Blockly.Blocks['gta_detect_face'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('检测人脸：')
      .appendField(' 最小尺寸')
      .appendField(new Blockly.FieldNumber(50, 10, 300,1), 'min_size')
      .appendField(' 最大尺寸')
      .appendField(new Blockly.FieldNumber(300, 10, 300,1), 'max_size')
    this.setStyle('detect_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('在屏幕显示检测到的人脸区域。参数：检测人脸区域的最小尺寸、最大尺寸。返回数组。备注：最多可以侦测5个；最大尺寸过小（约47）会触发错误且程序不继续执行，建议更改默认值为50到300。')
    this.setHelpUrl(Blockly.Msg['gta_detect_face'])
  },
}

Blockly.Python['gta_detect_face'] = function(block) {
  var number_min_size = block.getFieldValue('min_size')
  var number_max_size = block.getFieldValue('max_size')
  var code = `robot.detect_face(min_size=${number_min_size},max_size=${number_max_size})\n`
  return code
}


//打开地面检测
Blockly.Blocks['gta_turn_on_cliff_detection'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('打开地面检测')
    this.setStyle('detect_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('打开地面检测。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_turn_on_cliff_detection'])
  },
}

Blockly.Python['gta_turn_on_cliff_detection'] = function(block) {
  var code = `robot.turn_on_cliff_detection()\n`
  return code
}


//关闭地面检测
Blockly.Blocks['gta_turn_off_cliff_detection'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('关闭地面检测')
    this.setStyle('detect_blocks')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('关闭地面检测。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_turn_off_cliff_detection'])
  },
}

Blockly.Python['gta_turn_off_cliff_detection'] = function(block) {
  var code = `robot.turn_off_cliff_detection()\n`
  return code
}


// 查看（前）红外状态
Blockly.Blocks['gta_robot_read_infrared'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('查看 ')
      .appendField(
        new Blockly.FieldDropdown([
          ['前', 'front'],
          ['后', 'end'],
        ]),
        'group'
      )
      .appendField(' 红外状态')
    this.setInputsInline(true)
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setStyle('detect_blocks')
    this.setTooltip('查看机器人身体底部装置的红外。用于测距避障，检测前后是否有障碍。参数：选项为前进或后退。返回数组，需要可赋值给变量.')
    this.setHelpUrl(Blockly.Msg['gta_robot_read_infrared'])
  },
}

Blockly.Python['gta_robot_read_infrared'] = function(block) {
  var dropdown_group = block.getFieldValue('group')
  var code = `robot.read_infrared(location='${dropdown_group}')`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}



//读取陀螺仪数据1
Blockly.Blocks['gta_read_gyroscope'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('读取陀螺仪数据1')
    this.setStyle('detect_blocks')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true)
    this.setTooltip('读取陀螺仪的W, X, Y, Z四元数。返回数组，需要可赋值给变量')
    this.setHelpUrl(Blockly.Msg['gta_read_gyroscope'])
  },
}

Blockly.Python['gta_read_gyroscope'] = function(block) {
  var code = `robot.read_gyroscope()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}


//读取陀螺仪数据2
Blockly.Blocks['gta_read_gyroscope2'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('读取陀螺仪数据2')
    this.setStyle('detect_blocks')
    this.setOutput(true)
    this.setTooltip('读取陀螺仪的 pitch， roll， yaw数据。返回数组，需要可赋值给变量')
    this.setHelpUrl(Blockly.Msg['gta_read_gyroscope2'])
  },
}

Blockly.Python['gta_read_gyroscope2'] = function(block) {
  var code = `robot.read_gyroscope2()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}


// 获取人脸特征
Blockly.Blocks['gta_get_face_feature'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('获取人脸特征：')
      .appendField(new Blockly.FieldNumber(0, 0, 100,1), 'index')
    this.setStyle('detect_blocks')
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true);
    this.setTooltip('在屏幕显示指定索引值的人脸的五个关键点。无参数。返回数组')
    this.setHelpUrl(Blockly.Msg['gta_get_face_feature'])
  },
}

Blockly.Python['gta_get_face_feature'] = function(block) {
  var number_index = block.getFieldValue('index')
  var code = `robot.get_face_feature(index=${number_index})`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

/**
 * pattern detection  组件 
 * */

//  检测图案
Blockly.Blocks['gta_detect_pattern'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('检测图案类别')
      .appendField(
        new Blockly.FieldDropdown([
          ['数字', 'number'],
          ['字母', 'letter'],
          ['动物', 'animal'],
        ]),
        'group'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('detect_blocks')
    this.setTooltip('在屏幕显示检测到的指定类别的图案。参数选项为：数字、字母、动物。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_detect_pattern'])
  },
}

Blockly.Python['gta_detect_pattern'] = function(block) {
  var dropdown_group = block.getFieldValue('group')
  var code = `robot.detect_pattern(group='${dropdown_group}', min_size=10, max_size=300)\n`
  return code
}

// 获取图片路径
Blockly.Blocks['gta_get_pattern_location'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('通过索引')
      .appendField(new Blockly.FieldNumber(0, 0, 100,1), 'index')
      .appendField('获得图片路径')
    this.setInputsInline(true)
    // this.setPreviousStatement(true, null)
    // this.setNextStatement(true, null)
    this.setOutput(true);
    this.setStyle('detect_blocks')
    this.setTooltip('返回指定索引的位置参数。参数：索引值。返回：图片路径。')
    this.setHelpUrl(Blockly.Msg['gta_get_pattern_location'])
  },
}

Blockly.Python['gta_get_pattern_location'] = function(block) {
  var dropdown_index = block.getFieldValue('index')
  var code = `robot.get_pattern_location(index=${dropdown_index})`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

/**
 * video 组件
 * */

// 打开摄像头-功能：在主程序运行过程中开启服务，并持续显示图像
Blockly.Blocks['gta_display_video'] = {
  init: function() {
    this.appendDummyInput().appendField('打开摄像头')
    this.setStyle('robot_B_camera')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('在主程序运行过程中开启服务，并持续显示图像。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_display_video'])
  },
}

Blockly.Python['gta_display_video'] = function(block) {
  var code = `robot.display_video()\n`
  return code
}


// 获取摄像头图像
Blockly.Blocks['gta_robot_get_camera_image'] = {
  init: function() {
    this.appendDummyInput().appendField('获取摄像头图像')
    this.setStyle('robot_B_camera')
    this.setOutput(true)
    this.setTooltip(
      '获取当前摄像头的图像，返回网络图片地址。参数：无。返回：网络地址URL'
    )
    this.setHelpUrl(Blockly.Msg['gta_robot_get_camera_image'])
  },
}

Blockly.Python['gta_robot_get_camera_image'] = function(block) {
  var code = `robot.get_camera_image()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}




// 关闭录像
// Blockly.Blocks['gta_close_video'] = {
//   init: function() {
//     this.appendDummyInput().appendField('关闭录像')
//     this.setStyle('detect_blocks')
//     this.setPreviousStatement(true, null)
//     this.setNextStatement(true, null)
//     this.setTooltip('')
//     this.setHelpUrl(Blockly.Msg['gta_close_video'])
//   },
// }

// Blockly.Python['gta_close_video'] = function(block) {
//   var code = `robot.close_video()\n`
//   return code
// }

// 设备关闭摄像头画面
Blockly.Blocks['gta_robot_stop_showing'] = {
  init: function() {
    this.appendDummyInput().appendField('设备关闭摄像头画面')
    this.setStyle('robot_print')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setTooltip('停止机器屏幕的画面显示。无参数。无返回。')
    this.setHelpUrl(Blockly.Msg['gta_robot_stop_showing'])
  },
}

Blockly.Python['gta_robot_stop_showing'] = function(block) {
  var code = `robot.stop_showing()\n`
  return code
}


// // 打开视频数据流
// Blockly.Blocks['gta_open_video_data'] = {
//   init: function() {
//     this.appendDummyInput().appendField('打开视频数据流')
//     this.setStyle('detect_blocks')
//     this.setPreviousStatement(true, null)
//     this.setNextStatement(true, null)
//     this.setTooltip('')
//     this.setHelpUrl(Blockly.Msg['gta_open_video_data'])
//   },
// }

// Blockly.Python['gta_open_video_data'] = function(block) {
//   var code = `robot.open_video_data()\n`
//   return code
// }
// 关闭视频数据流
// Blockly.Blocks['gta_close_video_data'] = {
//   init: function() {
//     this.appendDummyInput().appendField('关闭视频数据流')
//     this.setStyle('detect_blocks')
//     this.setPreviousStatement(true, null)
//     this.setNextStatement(true, null)
//     this.setTooltip('')
//     this.setHelpUrl(Blockly.Msg['gta_close_video_data'])
//   },
// }

// Blockly.Python['gta_close_video_data'] = function(block) {
//   var code = `robot.close_video_data()\n`
//   return code
// }
// 获取录像中的图片
// Blockly.Blocks['gta_get_image_from_video'] = {
//   init: function() {
//     this.appendDummyInput().appendField('获取录像中的图片')
//     this.setStyle('detect_blocks')
//     this.setPreviousStatement(true, null)
//     this.setNextStatement(true, null)
//     this.setTooltip('')
//     this.setHelpUrl(Blockly.Msg['gta_get_image_from_video'])
//   },
// }

// Blockly.Python['gta_get_image_from_video'] = function(block) {
//   var code = `robot.get_image_from_video()\n`
//   return code
// }
